const currencyTypes = {
  SET_DISPLAY_CURRENCY: "SET_DISPLAY_CURRENCY",
  SET_EXCHANGE_RATES: "SET_EXCHANGE_RATES",
  SET_RATES_LOADING: "SET_RATES_LOADING",
};

export default currencyTypes;
